/** Human labels for the slot-related `skipped[].reason` values (CHANNEL_RESOLUTION.md §3, §5). */
export const SLOT_SKIP_REASON_LABELS: Record<string, string> = {
  slot_empty: 'Slot has no content here and no default',
  slot_missing: 'Slot no longer exists',
  slot_scope_not_allowed: 'Placed for a scope the slot no longer allows',
  slot_content_type: 'Slideshow uses element types the slot doesn’t allow',
  slot_item_limit: 'Over the slot’s item limit',
  slot_total_duration: 'Over the slot’s total time limit',
}
